// 值字段的 id 是固定的！
export const VALUE_FIELD = '$$value$$';
export const EXTRA_FIELD = '$$extra$$';
export const ORIGIN_FIELD = '$$origin$$';
export const EXTRA_COLUMN_FIELD = '$$extra_column$$';
export const TOTAL_VALUE = '$$total$$';
export const MULTI_VALUE = '$$multi$$';
export const SERIES_NUMBER_FIELD = '$$series_number$$';
export const EMPTY_FIELD_VALUE = '$$empty_field_value$$';
export const EMPTY_EXTRA_FIELD_PLACEHOLDER = '$$empty_extra_placeholder$$';
